import { render, staticRenderFns } from "./CampaignTask.vue?vue&type=template&id=0488eaa0&scoped=true&"
import script from "./CampaignTask.vue?vue&type=script&lang=js&"
export * from "./CampaignTask.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTask.vue?vue&type=style&index=0&id=0488eaa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488eaa0",
  null
  
)

export default component.exports